import { useCallback, useState } from "react";
import { toast } from "sonner";
import { listSignups } from "../lib/api";
import { HTTP_UNAUTHORIZED } from "../constants/http";

// In-memory only. We intentionally do NOT persist the admin key to
// localStorage / sessionStorage because it grants full read access to
// member data. The trade-off is that the admin must sign in again after
// a page refresh, which is acceptable for an internal tool.
export function useAdminAuth() {
  const [adminKey, setAdminKey] = useState("");
  const [verifying, setVerifying] = useState(false);

  const signIn = useCallback(async (key) => {
    if (!key || !key.trim()) {
      toast.error("Please enter the admin key.");
      return false;
    }
    setVerifying(true);
    try {
      // Probe the API with limit=1 so we only fetch what we need to verify the key.
      await listSignups(key, 1);
      setAdminKey(key);
      toast.success("Signed in.");
      return true;
    } catch (err) {
      const status = err?.response?.status;
      if (status === HTTP_UNAUTHORIZED) {
        toast.error("Invalid admin key.");
      } else {
        console.error("Admin sign-in failed:", err);
        toast.error("Could not sign in. Try again.");
      }
      return false;
    } finally {
      setVerifying(false);
    }
  }, []);

  const signOut = useCallback(() => {
    setAdminKey("");
    toast.success("Signed out.");
  }, []);

  return { adminKey, isAuthenticated: Boolean(adminKey), verifying, signIn, signOut };
}
